module.exports = __webpack_public_path__ + "static/img_1515-bccd430fd50beb927e12cf12c53619d1.webp";